import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const HelpImagePreviewPage = () => {
  const location = useLocation();

  const { src, alt } = useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      src: params.get("src") || "",
      alt: params.get("alt") || "",
    };
  }, [location.search]);

  useEffect(() => {
    document.title = alt ? `VelaKoda | ${alt}` : "VelaKoda | Image Preview";
  }, [alt]);

  if (!src) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: "24px",
          background: "#f6f8fb",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: "640px",
            padding: "20px 24px",
            borderRadius: "16px",
            background: "#fff",
            color: "#334155",
            boxShadow: "0 12px 34px rgba(15, 23, 42, 0.12)",
          }}
        >
          Image preview unavailable because the image URL is missing.
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "24px",
        background: "#f6f8fb",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          display: "block",
          maxWidth: "min(100%, 1600px)",
          height: "auto",
          borderRadius: "16px",
          boxShadow: "0 12px 34px rgba(15, 23, 42, 0.16)",
          background: "#fff",
        }}
      />
    </div>
  );
};

export default HelpImagePreviewPage;
